import React from 'react';

export default function Footer() {
    return (
        <div className="jumbotron jumbotron-fluid -as-footer">
            <div className="container">
                <div className="row">
                    <div className="col-md">
                        <a href="https://illinois.edu" target="_blank" rel="noopener noreferrer">
                            <img  alt="University of Illinois" src="https://illinois.edu/assets/img/branding/wordmark_horizontal.png" />
                        </a>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm">
                        <a rel="noopener noreferrer" target="_blank" className="social-link" href="https://linkedin.com/in/rogerngo90">
                            <i className="fa fa-linkedin-square"></i>                    
                        </a>
                        <a rel="noopener noreferrer" target="_blank" className="social-link" href="https://github.com/urbanspr1nter">
                            <i className="fa fa-github" aria-hidden="true"></i>
                        </a>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md">
                        Visualization by <h3 className="display-4">Roger Ngo</h3>
                    </div>
                    <div className="row">
                        <div className="col-md">
                            Email:&nbsp;<a rel="noopener noreferrer" href="mailto:rngo2@illinois.edu">rngo2@illinois.edu</a>
                        </div>
                        <div className="col-md">
                            Website:&nbsp;<a rel="noopener noreferrer" target="_blank" href="http://rogerngo.com">http://rogerngo.com</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );   
}